import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { AlertService, GrowlType } from '../../../infrastructure/services/alert.service';

@Component({
  selector: 'sx-value-builder',
  templateUrl: 'valueBuilder.component.html'
})
export class ValueBuilderComponent implements OnInit {

  @Input() label = '';

  @Input() comp: string = '';
  @Input() classes: string = 'col-md-10';

  mostrarConfirm = [];

  _items: string[] = [];
  @Output() resultList: EventEmitter<string> = new EventEmitter();

  @Input('items')
  set items(valu: string) {
      if (valu) {
        this._items = valu.split(',');
      } else {
        this._items = [];
      }
    }

  /** Item auxiliar que se utilizar para ir pusheando nuevos elementos */
  newItem: string;

  constructor(private alertService: AlertService) {
  }

  ngOnInit() {
  }

  add() {
    const arr = this.newItem.split(',');
    arr.forEach(el => this._items.push(el));
    this.newItem = '';
    this.resultList.emit(this._items.join(','));
  }

  remove(index) {
    this._items.splice(index, 1);
    this.mostrarConfirm[index] = false;
    this.resultList.emit(this._items.join(','));
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/valueBuilder/valueBuilder.component.ts